module.exports = __webpack_public_path__ + "img/px-1.19506ec6.png";